import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { buildRedirectUrl } from '../../utils/routeRedirect';

/**
 * Handles legacy route redirect from `/system-design/lld` to `/practice/lld`.
 * Preserves any query parameters from the original URL.
 * Requirement 17.5
 */
const LLDLegacyRedirect: React.FC = () => {
 const location = useLocation();
 const redirectUrl = buildRedirectUrl(location.pathname, location.search);

 return <Navigate to={redirectUrl} replace />;
};

export default LLDLegacyRedirect;
